import type { ReactElement } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectValue,
} from '@/components/ui/select';
import { SeveritySelectTrigger } from '@/components/ui/severity-select-trigger';
import { Severity } from '@kirin/api-client/contracts/shared/severity';
import type { SeverityType } from '@kirin/api-client/contracts/shared/severity';
import { SeverityBadge } from '@/components/policylist/components/SeverityBadge';

const SEVERITY_OPTIONS = [
  Severity.Medium,
  Severity.High,
  Severity.Critical,
] as const;

interface EnforcementSeverityThresholdControlProps {
  value: SeverityType;
  onChange: (severity: SeverityType) => void;
  disabled?: boolean;
  saving?: boolean;
  canEdit?: boolean;
}

export function EnforcementSeverityThresholdControl({
  value,
  onChange,
  disabled = false,
  saving = false,
  canEdit = true,
}: EnforcementSeverityThresholdControlProps): ReactElement {
  return (
    <div>
      <Select
        value={value}
        onValueChange={v => onChange(v as SeverityType)}
        disabled={disabled || saving || !canEdit}
      >
        <SeveritySelectTrigger>
          <SelectValue placeholder="Select severity" />
        </SeveritySelectTrigger>
        <SelectContent>
          {SEVERITY_OPTIONS.map(severity => (
            <SelectItem key={severity} value={severity}>
              <SeverityBadge
                riskLevel={severity}
                showIcon
                className="bg-transparent border-0 p-0"
              />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

EnforcementSeverityThresholdControl.displayName =
  'EnforcementSeverityThresholdControl';
